__turbopack_context__.v({
  "breadcrumb": "breadcrumb-module-scss-module__a7OOgq__breadcrumb",
  "custom-link": "breadcrumb-module-scss-module__a7OOgq__custom-link",
  "general-container": "breadcrumb-module-scss-module__a7OOgq__general-container",
  "partner-logo": "breadcrumb-module-scss-module__a7OOgq__partner-logo",
});
